(() => {
  const enhancePolicy = () => {
    const container = document.querySelector('.shopify-policy__container');
    const template = document.getElementById('PolicyEditorialTemplate');

    if (!container || !template || container.dataset.editorialEnhanced === 'true') return;

    const title = container.querySelector('.shopify-policy__title');
    const body = container.querySelector('.shopify-policy__body');
    const heading = title?.querySelector('h1');

    if (!title || !body || !heading) return;

    if (window.location.pathname.includes('/privacy-policy')) {
      const staleAddress = 'RUKN ALASIL ELECTRONICS TRADING L.L.C, 509 Baniyas Road, 0 Dubai DU';
      const verifiedAddress = 'RUKN ALASIL ELECTRONICS TRADING L.L.C, Gargash Center, Office 509, Dubai, UAE';
      const textNodes = document.createTreeWalker(body, NodeFilter.SHOW_TEXT);
      let textNode = textNodes.nextNode();
      while (textNode) {
        if (textNode.nodeValue.includes(staleAddress)) {
          textNode.nodeValue = textNode.nodeValue.replace(staleAddress, verifiedAddress);
        }
        textNode = textNodes.nextNode();
      }
    }

    const supplement = document.querySelector('[data-policy-supplement]');
    if (supplement) {
      while (supplement.firstChild) body.appendChild(supplement.firstChild);
      supplement.remove();
    }

    body.querySelectorAll('h1').forEach((embeddedTitle) => embeddedTitle.remove());
    const sectionHeadings = Array.from(body.querySelectorAll('h2'));

    const fragment = template.content.cloneNode(true);
    const header = fragment.querySelector('.policy-editorial__header');
    const titleSlot = fragment.querySelector('[data-policy-title-slot]');
    const aside = fragment.querySelector('.policy-editorial__aside');
    const toc = fragment.querySelector('[data-policy-toc]');

    if (template.dataset.policyTitle) {
      heading.textContent = template.dataset.policyTitle;
    }

    titleSlot.replaceWith(heading);
    title.remove();

    const layout = document.createElement('div');
    layout.className = 'policy-editorial__layout';
    const content = document.createElement('div');
    content.className = 'policy-editorial__content';

    sectionHeadings.forEach((sectionHeading, index) => {
      let sectionId = sectionHeading.id || sectionHeading.textContent
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');

      if (!sectionId) sectionId = `policy-section-${index + 1}`;
      if (document.getElementById(sectionId) && document.getElementById(sectionId) !== sectionHeading) sectionId = `${sectionId}-${index + 1}`;

      sectionHeading.id = sectionId;

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${sectionId}`;
      link.textContent = sectionHeading.textContent.trim();
      if (index === 0) link.setAttribute('aria-current', 'true');
      item.appendChild(link);
      toc.appendChild(item);
    });

    if (sectionHeadings.length === 0) {
      aside.querySelector('.policy-editorial__toc')?.remove();
    }

    const tocDetails = aside.querySelector('.policy-editorial__toc');
    if (tocDetails) {
      const mobileQuery = window.matchMedia('(max-width: 767.98px)');
      const syncTocState = (event) => {
        tocDetails.open = !event.matches;
      };

      syncTocState(mobileQuery);
      mobileQuery.addEventListener?.('change', syncTocState);
    }

    content.append(body);
    layout.append(content, aside);
    container.append(header, layout);
    container.dataset.editorialEnhanced = 'true';

    const tocLinks = Array.from(container.querySelectorAll('[data-policy-toc] a'));
    if ('IntersectionObserver' in window && sectionHeadings.length > 0) {
      const observer = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];

        if (!visible) return;

        tocLinks.forEach((link) => {
          if (link.hash === `#${visible.target.id}`) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      }, {
        rootMargin: '-18% 0px -68% 0px',
        threshold: 0
      });

      sectionHeadings.forEach((sectionHeading) => observer.observe(sectionHeading));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhancePolicy, { once: true });
  } else {
    enhancePolicy();
  }
})();
